// the following global variables should be defined before the mxgraph is loaded
// https://jgraph.github.io/mxgraph/docs/js-api/files/index-txt.html
window.mxBasePath = 'static/mxgraph'
// window.mxLoadResourcesmx = false
// window.LoadStylesheets = false



// WEBPACK FOOTER //
// ./src/globals.js